import React, { memo } from "react";
import { NumericFormat } from "react-number-format";

function NumericLabel(props) {
  const { isCurrency = false, isSeparator = false, value = "" } = props;
  return (
    <NumericFormat
      prefix={isCurrency ? "$" : ""}
      value={value}
      displayType="text"
      thousandSeparator={isSeparator || isCurrency}
    />
  );
}

export default memo(NumericLabel);
